// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var $$String = require("rescript/lib/js/string.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var DOM$SmartcutsMacros = require("./DOM.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var DOM__Shadow$SmartcutsMacros = require("./DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("./DOM__Element.bs.js");
var DOM__Attributes$SmartcutsMacros = require("./DOM__Attributes.bs.js");
var DOM__DataTransfer$SmartcutsMacros = require("./DOM__DataTransfer.bs.js");
var Virtualized__Input$SmartcutsMacros = require("./Virtualized__Input.bs.js");
var DOM__HtmlInputElement$SmartcutsMacros = require("./DOM__HtmlInputElement.bs.js");

var empty = CustomMap$SmartcutsMacros.MapDomElement.make(undefined);

var get = Belt_Map.get;

var set = Belt_Map.set;

var has = Belt_Map.has;

var update = Belt_Map.update;

function updateWithDomEvent(domElementIdentifierGenerator, $$event, inputByDomElement) {
  switch ($$event.TAG | 0) {
    case /* MouseEvent */0 :
        if ($$event._0 !== "click") {
          return inputByDomElement;
        }
        var mouseEvent = $$event._1;
        var match = DOM$SmartcutsMacros.MouseButtonPressed.fromMouseEvent(mouseEvent);
        if (match !== 0) {
          return inputByDomElement;
        }
        var targetElement = DOM__Shadow$SmartcutsMacros.getTargetFromEvent(mouseEvent);
        if (DOM__Element$SmartcutsMacros.checkSelectionStartCapability(targetElement) && DOM__Element$SmartcutsMacros.isVisibleOnPage(targetElement)) {
          return Belt_Map.update(inputByDomElement, targetElement, (function (maybeInput) {
                        if (maybeInput === undefined) {
                          return Virtualized__Input$SmartcutsMacros.make(targetElement);
                        }
                        var clickCount = mouseEvent.detail;
                        return clickCount > 1 && DOM__HtmlInputElement$SmartcutsMacros.doesSupportSelection(targetElement) && targetElement.selectionStart !== targetElement.selectionEnd ? ({
                                    value: targetElement.value,
                                    cursor: maybeInput.cursor
                                  }) : Virtualized__Input$SmartcutsMacros.updateCursorAndValueToMatchHtmlInputElement(targetElement, maybeInput);
                      }));
        } else {
          return inputByDomElement;
        }
    case /* InputEvent */1 :
        if ($$event._0 !== "input") {
          return inputByDomElement;
        }
        var targetElement$1 = DOM__Shadow$SmartcutsMacros.getTargetFromEvent($$event._1);
        var tagName = targetElement$1.tagName.toLowerCase();
        var match$1 = DOM__Attributes$SmartcutsMacros.ofDomElement(targetElement$1);
        var match$2 = OptionUtils$SmartcutsMacros.map(match$1.type_, $$String.lowercase_ascii);
        switch (tagName) {
          case "input" :
              if (match$2 !== undefined) {
                switch (match$2) {
                  case "email" :
                  case "password" :
                  case "search" :
                  case "tel" :
                  case "text" :
                  case "url" :
                      break;
                  default:
                    return inputByDomElement;
                }
              }
              break;
          case "textarea" :
              break;
          default:
            return inputByDomElement;
        }
        return Belt_Map.update(inputByDomElement, targetElement$1, (function (maybeInput) {
                      if (maybeInput !== undefined) {
                        return Virtualized__Input$SmartcutsMacros.updateCursorAndValueToMatchHtmlInputElement(targetElement$1, maybeInput);
                      } else {
                        return Virtualized__Input$SmartcutsMacros.make(targetElement$1);
                      }
                    }));
        break;
    case /* ClipboardEvent */3 :
        if ($$event._0 !== "paste") {
          return inputByDomElement;
        }
        var clipboardEvent = $$event._1;
        var data = clipboardEvent.clipboardData;
        var pastedText = DOM__DataTransfer$SmartcutsMacros.getData("text", data);
        var targetElement$2 = DOM__Shadow$SmartcutsMacros.getTargetFromEvent(clipboardEvent);
        var htmlInputElement = DOM__HtmlInputElement$SmartcutsMacros.ofElement(targetElement$2);
        if (htmlInputElement === undefined) {
          return inputByDomElement;
        }
        var htmlInputElement$1 = Caml_option.valFromOption(htmlInputElement);
        return Belt_Map.update(inputByDomElement, targetElement$2, (function (maybeInput) {
                      if (maybeInput !== undefined) {
                        return Virtualized__Input$SmartcutsMacros.updateWithPastedText(domElementIdentifierGenerator, htmlInputElement$1, pastedText, maybeInput);
                      } else {
                        return Virtualized__Input$SmartcutsMacros.makeWithPastedText(domElementIdentifierGenerator, htmlInputElement$1, pastedText);
                      }
                    }));
    case /* Event */9 :
        if ($$event._0 !== "selectionchange") {
          return inputByDomElement;
        }
        var activeDomElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
        var maybeActiveDomElementWithCheckSelectionStartCapability;
        if (activeDomElement !== undefined) {
          var activeDomElement$1 = Caml_option.valFromOption(activeDomElement);
          maybeActiveDomElementWithCheckSelectionStartCapability = DOM__Element$SmartcutsMacros.checkSelectionStartCapability(activeDomElement$1) ? Caml_option.some(activeDomElement$1) : undefined;
        } else {
          maybeActiveDomElementWithCheckSelectionStartCapability = undefined;
        }
        if (maybeActiveDomElementWithCheckSelectionStartCapability === undefined) {
          return inputByDomElement;
        }
        var activeDomElement$2 = Caml_option.valFromOption(maybeActiveDomElementWithCheckSelectionStartCapability);
        return Belt_Map.update(inputByDomElement, activeDomElement$2, (function (maybeInput) {
                      if (maybeInput !== undefined) {
                        return Virtualized__Input$SmartcutsMacros.updateCursorAndValueToMatchHtmlInputElement(activeDomElement$2, maybeInput);
                      } else {
                        return Virtualized__Input$SmartcutsMacros.make(activeDomElement$2);
                      }
                    }));
    default:
      return inputByDomElement;
  }
}

var VirtualizedInputByDomElement = {
  empty: empty,
  get: get,
  set: set,
  has: has,
  update: update,
  toList: Belt_Map.toList,
  updateWithDomEvent: updateWithDomEvent
};

function t_encode(v) {
  return Curry._2(CustomMap$SmartcutsMacros.MapSelector.t_encode, Virtualized__Input$SmartcutsMacros.t_encode, v);
}

function t_decode(v) {
  return Curry._2(CustomMap$SmartcutsMacros.MapSelector.t_decode, Virtualized__Input$SmartcutsMacros.t_decode, v);
}

function fromInputByDomElement(inputByDomElement) {
  return Curry._1(CustomMap$SmartcutsMacros.MapSelector.fromArray, $$Array.map((function (param) {
                    return [
                            Selector$SmartcutsMacros.forDomElement(param[0]),
                            param[1]
                          ];
                  }), Belt_Map.toArray(inputByDomElement)));
}

var VirtualizedInputBySelector = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromInputByDomElement: fromInputByDomElement,
  toList: Belt_Map.toList
};

var VirtualizedInput;

exports.VirtualizedInput = VirtualizedInput;
exports.VirtualizedInputByDomElement = VirtualizedInputByDomElement;
exports.VirtualizedInputBySelector = VirtualizedInputBySelector;
/* empty Not a pure module */
